import type { KubernetesLiveApplicationStatusCode, KubernetesLiveResourceSyncStatusCode } from "@octopusdeploy/octopus-server-client";

export const StatusDisplayLookup: Record<KubernetesLiveApplicationStatusCode | KubernetesLiveResourceSyncStatusCode, string> = {
    Healthy: "Healthy",
    Progressing: "Progressing",
    OutOfSync: "Out of Sync",
    Missing: "Missing",
    Degraded: "Degraded",
    Unknown: "Unknown",
    NotSupported: "Not Supported",
    Waiting: "Waiting",
    Unavailable: "Unavailable",
    Stale: "Stale",
    InSync: "In Sync",
    GitDrift: "Git Drift",
    NotApplicable: "Not Applicable",
};
